import React from "react";
import { Color } from "cesium";
import { Viewer, GeoJsonDataSource } from "resium";

function Test() {
  return (
    <Viewer full timeline={false} animation={false}>
      <GeoJsonDataSource
        data="/geojson/buffer/2022-07-24.geojson"
        fill={Color.TRANSPARENT}
        stroke={Color.FUCHSIA}
        strokeWidth={10}
      />
    </Viewer>
  );
}

export default Test;
